import { createStore, combineReducers } from 'redux';
import carPlanReducer from './reducers/carPlanReducer';
import healthPlanReducer from './reducers/healthPlanReducer';
import lifePlanReducer from './reducers/lifePlanReducer';
import quoteHealthDetailsReducer from './reducers/quoteHealthDetailsReducer';
import healthQuestionnaireReducer from './reducers/healthQuestionnaire';
import carQuoteListReducer from './reducers/carQuoteListReducer';
import tokenReducer from './reducers/tokenReducer';
import healthVerifyIdReducer from './reducers/healthVerifyId';
import healthNominationReducer from './reducers/healthNominationReducer';
import vehicleInfoReducer from './reducers/vehicleInfoReducer';
import orderDetailsIdReducer from './reducers/orderDetailsReducer';
import carAddOnReducer from './reducers/carAddOnReducer';
import carAddOnSelectionReducer from './reducers/carAddOnSelectionReducer';
import orderIdReducer from './reducers/orderIdReducer';

const rootReducer = combineReducers({
    carPlan: carPlanReducer,
    vehicle: vehicleInfoReducer,
    healthPlan: healthPlanReducer,
    lifePlan: lifePlanReducer,
    quoteHealthDetails: quoteHealthDetailsReducer,
    healthQuestionnaire: healthQuestionnaireReducer,
    healthVerifyId: healthVerifyIdReducer,
    healthNomination: healthNominationReducer,
    carQuoteList: carQuoteListReducer,
    orderDetailsId: orderDetailsIdReducer,
    ansa_token: tokenReducer,
    addOn: carAddOnReducer,
    addOnSelection: carAddOnSelectionReducer,
    order_id: orderIdReducer,
});

// Create the Redux store
const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;